import type { DomainMapper } from '../types';

const at: DomainMapper = {
  countryCode: 'at',
  currency: 'EUR',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/AT.svg',
  languagePrimary: false,
  locale: 'de',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-at.xml',
  storyblokBasePath: 'at',
  url: 'https://kahrs-stage.iveo.store/at',
  algoliaIndex: 'b2c-at-de-DE-products',
  algoliaIndexAutocomplete: 'b2c-at-de-DE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1636,
  subFolder: true,
  b2b: {
    enabled: false,
    purchaseEnabled: false,
    storyblokBasePath: 'b2b',
    applicationId: 1636,
    algoliaIndex: 'b2c-at-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-at-de-DE-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-at.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1636,
    algoliaIndex: 'b2c-at-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-at-de-DE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-at-b2c.xml',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
  },
  features: {
    fastOrder: false,
    backorders: false,
    cartSettings: true,
    disableShipToConsumer: false,
    onlyAllowCustomerEditAddressesForSamples: true,
  },
} as DomainMapper;

export default at;
